<div
  class="adf-upload-widget {{field.className}}"
  [class.adf-invalid]="!field.isValid"
  [class.adf-readonly]="field.readOnly"
>
  <label class="adf-label" [attr.for]="field.id"
    >{{field.name | translate }}<span *ngIf="isRequired()">*</span></label
  >
  <div class="adf-upload-widget-container">
    <div>
      <mat-list *ngIf="hasFile">
        <mat-list-item
          class="adf-upload-files-row"
          *ngFor="let file of field.value"
        >
          <img
            mat-list-icon
            class="adf-upload-widget__icon"
            [id]="'file-'+file.id+'-icon'"
            [src]="getIcon(file.mimeType)"
            [alt]="mimeTypeIcon"
            (click)="onFileClicked(file)"
            (keyup)="onFileClicked(file)"
          />
          <a
            matLine
            id="{{'file-'+file.id}}"
            (click)="onFileClicked(file)"
            (keyup.enter)="onFileClicked(file)"
            class="adf-file"
            >{{file.name}}</a
          >
        </mat-list-item>
      </mat-list>
    </div>

    <div *ngIf="(!hasFile || multipleOption) && !field.readOnly">
      <button
        mat-raised-button
        color="primary"
        (click)="uploadFiles.click()"
        (keyup.enter)="uploadFiles.click()"
      >
        {{ 'FORM.FIELD.UPLOAD' | translate }}<mat-icon>file_upload</mat-icon>
        <input
          #uploadFiles
          [multiple]="multipleOption"
          type="file"
          [id]="field.id"
          (change)="onFileChanged($event)"
        />
      </button>
    </div>
  </div>
  <error-widget [error]="field.validationSummary"></error-widget>
  <error-widget
    *ngIf="isInvalidFieldRequired()"
    required="{{ 'FORM.FIELD.REQUIRED' | translate }}"
  ></error-widget>
</div>
